<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="headline green darken-2">
          {{title}}
          <v-btn class="ml-auto" color="red darken-1" x-small fab @click="checkAction = false">
              <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-actions>
          <v-text-field dense @keypress="checkCellNum($event)" :hide-details="true" label="ZIP" v-model="zip" outlined></v-text-field>
        </v-card-actions>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="!zip" color="primary" text @click="save">SAVE</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
	props: [ "data-zip", "data-action" ],
	data() {
		return {
			checkAction: false,
			zip: null,
			title: 'Create Zip'
		};
	},
	computed: {
		dialog: {
			get: function() {
				return this.checkAction;
			},
			set: function(val) {
				this.checkAction = val;
			},
		},
	},
	mounted() {
		this.checkAction = this.dataAction;
		this.zip = this.dataZip.value;
	},
	methods: {
		close() {
			this.$emit("close-dialog");
		},
		save() {
			this.dataZip.value = this.zip;
			this.$emit('save-creater');
		},
		checkCellNum(evt) {
			const regex = new RegExp("^[0-9]+$");
			const key = String.fromCharCode(!evt.charCode ? evt.which : evt.charCode);
			if (!regex.test(key)) {
				event.preventDefault();
				return false;
			}
		}
	},
	watch: {
		checkAction(val) {
			if (!val) this.close();
		},
	},
};
</script>
<style lang="scss" scoped>
@import "./create-zip.component";
</style>
